import { Card, Typography } from "antd";
import type { ReactNode } from "react";

type AdminPageProps = {
	title: string;
	subtitle?: string;
	extra?: ReactNode;
	filters?: ReactNode;
	toolbar?: ReactNode;
	children?: ReactNode;
	/** When false, render children without the white card. */
	card?: boolean;
};

export function AdminPage({
	title,
	subtitle,
	extra,
	filters,
	toolbar,
	children,
	card = true,
}: AdminPageProps) {
	return (
		<div className="admin-page">
			<div className="admin-page-header">
				<div className="admin-page-titles">
					<Typography.Title level={3} className="admin-page-title">
						{title}
					</Typography.Title>
					{subtitle ? (
						<div className="admin-page-subtitle">{subtitle}</div>
					) : null}
				</div>
				{extra ? <div className="admin-page-extra">{extra}</div> : null}
			</div>
			{filters ? <div className="admin-page-filters">{filters}</div> : null}
			{toolbar ? <div className="admin-page-toolbar">{toolbar}</div> : null}
			{card ? (
				<Card
					className="admin-page-card"
					bordered
					styles={{ body: { padding: 0 } }}
				>
					{children}
				</Card>
			) : (
				children
			)}
		</div>
	);
}
